var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03345 4H8.38007L6.20214 7.9976H2.49438C2.50766 7.98193 2.5212 7.96642 2.535 7.95107L5.45016 4.70625C5.85403 4.25672 6.42954 4 7.03345 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.59662C2.03926 9.97763 2.18119 10.3511 2.42752 10.6731L11.091 22L6.13552 9.59662H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85571 9.59662L12 19.9697L16.1443 9.59662H7.85571Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8646 9.59662L12.9091 22L21.5726 10.6731C21.8189 10.3511 21.9608 9.97763 22.0001 9.59662H17.8646Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5056 7.9976H17.7979L15.62 4H16.9666C17.5705 4 18.146 4.25672 18.5499 4.70625L21.465 7.95107C21.4788 7.96642 21.4924 7.98193 21.5056 7.9976Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9786 7.9976H8.02136L10.1993 4H13.8007L15.9786 7.9976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondAlt);
export default __webpack_public_path__ + "static/media/diamond-alt.8889077dc1e935ec426d1ba5ceb6c56a.svg";
export { ForwardRef as ReactComponent };